module.exports = __webpack_public_path__ + "img/cp_zhcl01.1f7a5975.png";